import { queryCatalogExactCandidates } from "./catalog-index.js";

// Query unions use original display names only. Aliases, punctuation folding,
// grades and shared icons do not establish that two items have the same name.
const nameKey = value => String(value ?? "").trim().toLocaleLowerCase().replace(/\s+/gu, " ");

export function queryItemNameGroup(members) {
  const name = String(members[0]?.name ?? "").trim();
  const key = nameKey(name);
  if (!key || members.some(member => nameKey(member.name) !== key)) return null;
  const itemIds = [...new Set(members.map(member => member.itemId))].sort((a, b) => a - b);
  if (itemIds.length < 2 || itemIds.some(id => !Number.isSafeInteger(id) || id <= 0)) return null;
  return { name, itemIds };
}

// Index records opt in with their source itemId and itemName. A title, zone,
// authored quest group or alias-only match cannot join an item-name union.
export function findQueryItemNameGroup(indexes, value) {
  const key = nameKey(value);
  if (!key) return null;
  const records = new Map();
  for (const index of indexes) {
    for (const record of queryCatalogExactCandidates(index, value)) {
      if (record.itemId && nameKey(record.itemName) === key && !records.has(record.itemId)) {
        records.set(record.itemId, record);
      }
    }
  }
  const members = [...records.values()];
  const group = queryItemNameGroup(members.map(record => ({ itemId: record.itemId, name: record.itemName })));
  return group ? { ...group, records: members } : null;
}
